import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewServiceLayer from "../components/ViewServiceLayer";

const AddServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Service Details' />

        {/* AddBlogLayer */}
        <ViewServiceLayer />
      </MasterLayout>
    </>
  );
};

export default AddServicePage;